import React, { useEffect, useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import biomeApi from '../biome.api';
import { useNavigate, useParams } from 'react-router-dom';
import { updateBiomeApi } from '../biomeSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faCheck } from '@fortawesome/free-solid-svg-icons';
import { handleThunkException } from '~/services/thunk.service';

const updateSchema = Yup.object().shape({
    biome_name: Yup.string().required(),
});

function BiomeInfo() {
    // Get ID from URL
    const params = useParams();
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const [biomeName, setBiomeName] = useState('');
    const [disabledBiome, setDisabledBiome] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchBiomeDetail = async () => {
        let { status, data, error } = await biomeApi.getBiomeDetails(params.id);

        if (status) {
            setBiomeName(data.biome_name);
        } else {
            handleThunkException(error, dispatch, navigate);
        }
    };

    useEffect(() => {
        fetchBiomeDetail();

        return () => {
            dispatch(clearApiValidationErrors());
        };
    }, []);

    const formSubmit = (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateBiomeApi({ navigate, id: params.id, values, setDisabledBiome }));
    };

    return (
        <Card>
            <Card.Body>
                <Row sm={12}>
                    <Col>
                        <h4>Biome Info</h4>
                    </Col>
                </Row>
                <Formik
                    initialValues={{
                        biome_name: biomeName,
                    }}
                    validationSchema={updateSchema}
                    onSubmit={async (values) => {
                        const submitValues = JSON.parse(JSON.stringify(values));
                        formSubmit(submitValues);
                    }}
                    enableReinitialize={true}
                >
                    {({ isSubmitting, handleSubmit }) => (
                        <Form
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Row
                                sm={12}
                                className="justify-content-center"
                            >
                                <Col sm={3}>
                                    <div className="form-group">
                                        <Field
                                            name="biome_name"
                                            disabled={isSubmitting || disabledBiome}
                                            className="form-control mt-3"
                                            placeholder="Biome name"
                                        />
                                        <ErrorMessage
                                            component="div"
                                            className="invalid-feedback d-block"
                                            name="biome_name"
                                        />
                                        <div className={`form-main`}>
                                            {apiValidationErrors.length > 0 && (
                                                <div
                                                    className="py-1"
                                                    style={{ color: 'red' }}
                                                >
                                                    {apiValidationErrors[0]}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={1}>
                                    <div className="form-group">
                                        <Button
                                            hidden={disabledBiome}
                                            type="submit"
                                            className={'bg-info  border border-info mr-3 mt-3'}
                                        >
                                            <FontAwesomeIcon icon={faCheck} />
                                        </Button>
                                        <Button
                                            hidden={!disabledBiome}
                                            type="button"
                                            className={'bg-info  border border-info mr-3 mt-3'}
                                            onClick={() => {
                                                setDisabledBiome(!disabledBiome);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faPencil} />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
}

export default BiomeInfo;
